import { Input, Output, EventEmitter, Directive } from '@angular/core'
import { postInContext } from 'logic/post-states'
import sweetAlert from 'bmAlert'
import { Post, Customer, User } from 'src/modules/submissions/submission.queries'

@Directive()
export class BasePostForm {
  @Input() post: Post;
  @Input() customer: Customer;
  @Input() currentUser: User;
  @Output() close: EventEmitter<null> = new EventEmitter<null>();
  @Output() dirtyChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deprecatedStoreChange: EventEmitter<number> = new EventEmitter<number>()
  submitted: boolean = false;
  dirty: boolean = false;

  onSubmit(): void {}

  onClose(): void {
    if (!this.dirty) {
      this.setDirty(false)
      this.close.emit()
    } else {
      sweetAlert.confirm({text: "Are you sure? All unsaved changes will be lost."}).then(confirm => {
        if (confirm) {
          this.setDirty(false)
          this.close.emit()
        }
      })
    }
  }

  // Called with false in onSubmits, onCreates, etc...
  setDirty(dirty: boolean): void {
    this.dirty = dirty
    this.dirtyChanged.emit(this.dirty)
  }

  onModelChange(modelName: string, newValue: string) {
    this[modelName] = newValue
    this.setDirty(true)
  }

  inContext(context: string): boolean {
    return postInContext(this.post, context)
  }
}
